import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, BookOpen, Trophy } from "lucide-react";
import SpeakerButton from "./SpeakerButton";
import { fetchNextLesson } from "../lib/api";

export const NextLessonChip = ({ refreshKey = 0 }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchNextLesson().then(setData).catch(() => setData(null));
  }, [refreshKey]);

  if (!data) return null;

  if (data.all_complete) {
    return (
      <motion.div
        initial={{ opacity: 0, y: -6 }}
        animate={{ opacity: 1, y: 0 }}
        className="flex items-center gap-3 eigoo-glass rounded-2xl px-5 py-3 border-yellow-300/40"
        data-testid="next-lesson-chip"
      >
        <Trophy className="text-yellow-300" size={20} />
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-[0.25em] text-yellow-300/80 font-display">Curriculum</div>
          <div className="font-display font-bold text-base">All lessons complete · Top of the Fleet</div>
        </div>
        <SpeakerButton text="You have completed every lesson in Signal Science. Visit the Academy to retake any quiz, or charter your Privateer in the Mentor Bridge." testid="speaker-next-lesson" size="sm" />
      </motion.div>
    );
  }

  const isRed = data.module_color === "red";
  return (
    <motion.div
      initial={{ opacity: 0, y: -6 }}
      animate={{ opacity: 1, y: 0 }}
      className={`flex items-center gap-3 eigoo-glass rounded-2xl px-5 py-3 ${isRed ? "border-red-500/40" : "border-yellow-300/40"}`}
      data-testid="next-lesson-chip"
    >
      <div className={`h-10 w-10 rounded-xl flex items-center justify-center font-display font-black ${isRed ? "bg-red-500/15 text-red-300 border border-red-500/40" : "bg-yellow-300/15 text-yellow-300 border border-yellow-300/40"}`}>
        {data.module_numeral}
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-[0.25em] text-yellow-300/80 font-display">Up Next · Module {data.module_numeral}</div>
        <div className="font-display font-bold text-base md:text-lg leading-tight truncate">{data.lesson_title}</div>
        {data.power_word && <div className="text-xs text-white/50 truncate">Power word: <span className="text-yellow-200">{data.power_word}</span></div>}
      </div>
      <SpeakerButton text={`Up next: Module ${data.module_numeral}, ${data.lesson_title}.`} testid="speaker-next-lesson" size="sm" />
      <Link to="/academy" className="btn-eigoo btn-gold !min-h-0 !py-2 !px-4 text-sm" data-testid="goto-next-lesson">
        <BookOpen size={14} /> Begin <ArrowRight size={14} />
      </Link>
    </motion.div>
  );
};

export default NextLessonChip;
